module.exports = __webpack_public_path__ + "site-build/img/icon-5.e0938e64.svg";